import { render, staticRenderFns } from "./AddClientAddress.vue?vue&type=template&id=138c041e&scoped=true"
import script from "./AddClientAddress.vue?vue&type=script&lang=js"
export * from "./AddClientAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-load_857a25aa4406afef410ce4b662efafed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138c041e",
  null
  
)

export default component.exports